import React, { Component } from 'react'
import { COLORS } from '../pages/theme';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import { generateURL } from '../util/ui_util';
import { ClearOutlined } from '@material-ui/icons';


const getColor = (type) => {
    switch (type) {
        case "SUCCESS":
            return COLORS.success_primary;
            break;
        case "INFO":
            return COLORS.primary
            break;
        case "ERROR":
            return COLORS.danger_primary
            break;
        case "ALERT":
            return COLORS.warning_primary
            break;
        default:
            return COLORS.secondary

    }
}
const getColorSecondary = (type) => {
    switch (type) {
        case "SUCCESS":
            return COLORS.success_secondary;
            break;
        case "INFO":
            return COLORS.primary_off
            break;
        case "ERROR":
            return COLORS.danger_secondary
            break;
        case "ALERT":
            return COLORS.warning_secondary
            break;
        default:
            return COLORS.white

    }
}

class NotificationItem extends Component {
    render() {
        let data = this.props.data || {};
        let trigger_actions = data.trigger_actions || [];
        let marked=true;
        if(trigger_actions.length>0&&data.has_clicked==false){
            marked=false;
        }

        return (
            <div style={{
                display:'flex',
                flexDirection:'row',
                flexWrap:'nowrap',
                alignItems:'center',
                width:'100%'
            }}>
            <div className='filter-card' style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                padding:0,
                overflow:'hidden',
                position:'relative',
                flex:1,
                margin:0,
                marginBottom:8,
                backgroundColor:!marked?COLORS.border_basic:null
                // backgroundColor:getColorSecondary(data.type)
            }}>
                <div style={{
                    width:5,
                    backgroundColor:getColor(data.type)
                }}></div>
                <div style={{
                    display:'flex',
                    flex:1,
                    paddingTop:16,
                    paddingBottom:16,
                    paddingLeft:30,
                    paddingRight:16
                }}>
                    <div style={{
                        display:'flex',
                        flexDirection:'column',
                        width:'100%'
                    }}>
                        <div style={{
                            display:'flex',
                            flexDirection:'row',
                            justifyContent:'space-between',
                            flexWrap:'nowrap'
                        }}>
                        <div className='heading-2'>{data.title}</div>
                        <div>{data.created_at}</div>
                        </div>
                        <div style={{
                            marginTop:10
                        }} className='sub-heading-3'>{data.message}</div>
                        {trigger_actions.length>0?
                        <div style={{
                            paddingTop:26
                        }}>
                        {trigger_actions.map((item)=>{
                            if(item.type=="VIEW"){
                                return <Link  to={generateURL(item)} onClick={()=>{
                                    if(!marked){
                                    typeof this.props.onMark==='function'&&this.props.onMark(data.id);
                                    }
                                }}>
                                    <span className='sub-heading-3 hand-cursor' style={{
                                        color:COLORS.secondary,
                                        marginRight:65
                                    }} >
                                        {item.label}
                                    </span>
                                    {/* <Tag className='hand-cursor' color={COLORS.primary}>
                                        {item.label}
                                    </Tag> */}
                                </Link>
                            }else if(item.type=="PLUGIN"){
                                return <span className='sub-heading-3 hand-cursor' style={{
                                    color:COLORS.secondary,
                                    marginRight:65
                                }} 
                                onClick={()=>{
                                    typeof this.props.onTriggerAction==='function'&&this.props.onTriggerAction(item,data);
                                    if(!marked){
                                        typeof this.props.onMark==='function'&&this.props.onMark(data.id);
                                    }
                                }}
                                >
                                    {item.label}
                                </span>
                                // <Tag 
                                // className='hand-cursor'
                                // onClick={()=>{
                                //     typeof this.props.onTriggerAction==='function'&&this.props.onTriggerAction(item,data);
                                // }}
                                // color={COLORS.primary}>
                                //         {item.label}
                                //     </Tag>
                            }
                        })}
                        </div>:null}

                    </div>
                </div>

            </div>
            
            <ClearOutlined titleAccess="Delete" className='hand-cursor' style={{margin:16}} onClick={()=>{
                typeof this.props.onDelete==='function'&&this.props.onDelete(data.id)
            }}/>

            </div>
        )
    }
}

export default NotificationItem
